<div class="wrapper-md" *ngIf="document">
    <app-breadcrumbs [items]="[
                     { url: '/vaccination-documents', text: 'vaccinationDocument_listTitle' },
                     {
                        url: '/vaccination-documents/' + document.Id,
                        text: document.Type
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{document.Type}}
            <app-vaccination-document-status [value]="document.Status"></app-vaccination-document-status>
        </h1>
    </header>

    <app-alert [level]="document.Status == 'Approved' ? 'success' : 'danger'" *ngIf="document.ApprovalComment">
        <label>{{'vaccinationDocument_lblApprovalComment' | translate}}</label>
        <div>{{document.ApprovalComment}}</div>
    </app-alert>

    <div class="data-value" *ngIf="canPickStudent">
        <label>{{'vaccinationDocument_lblStudent' | translate}}</label>
        <div>{{document.OwnerFullName}} ({{document.OwnerUserName}})</div>
    </div>

    <div class="data-value">
        <label>{{'vaccinationDocument_lblType' | translate}}</label>
        <div>{{document.Type}}</div>
    </div>

    <div class="data-value" *ngIf="document.PolicyNumber">
        <label>{{'vaccinationDocument_lblPolicyNumber' | translate}}</label>
        <div>{{document.PolicyNumber}}</div>
    </div>

    <div class="data-value" *ngIf="document.Expires">
        <label>{{'vaccinationDocument_lblExpires' | translate}}</label>
        <div>{{document.Expires | appDate}}</div>
    </div>

    <div class="data-value">
        <label>{{'vaccinationDocument_lblPerson' | translate}}</label>
        <div>{{document.OwnerFullName}} ({{document.OwnerUserName}})</div>
    </div>

    <div class="data-value">
        <label>{{'vaccinationDocument_lblNotes' | translate}}</label>
        <div>{{document.Notes}}</div>
    </div>

    <div class="data-value">
        <label>{{'vaccinationDocument_lblFile' | translate}}</label>
        <div>
            <a *ngIf="document.FileName" href="#" (click)="$event.preventDefault(); download(document)">
                {{document.FileName}}
            </a>
        </div>
    </div>

    <div class="form-actions">
        <span class="form-actions-group" *ngIf="canReview">
            <button class="btn btn-outline-primary" type="button" (click)="review()">
                <i class="fi fi-rs-text-check"></i>
                {{'vaccinationDocument_btnReview' | translate}}
            </button>
        </span>

        <span class="form-actions-group">
            <button class="btn btn-outline" type="button" [routerLink]="['/vaccination-documents'] | localize">
                {{'vaccinationDocument_btnClose' | translate}}
            </button>
        </span>
    </div>
</div>
